<template>
  <div class="events-page">
    <div class="events-container">
      <!-- Add your events directly here -->
      <div class="event-card">
        <img src="../assets/posters/pb1.jpg" alt="python bootcamp-1">
        <div class="event-details">
          <h3>PYTHON BOOTCAMP - 1</h3>
          <p>August 17, 2023</p>
          <a href="https://docs.google.com/document/d/1R1YIN39iDqitp8ZiZt090883vlK1TRQP/edit?usp=sharing&ouid=111409979811802577162&rtpof=true&sd=true" target="_blank">Learn More</a>
        </div>
      </div>

      <div class="event-card">
        <img src="../assets/posters/pb2.jpg" alt="python bootcamp - 2">
        <div class="event-details">
          <h3>PYTHON BOOTCAMP - 2</h3>
          <p>August 30, 2023</p>
          <a href="https://drive.google.com/file/d/16HjwwQk8AQLJSoaqApcYgxJnUKiEYxUT/view?usp=sharing" target="_blank">Learn More</a>
        </div>
      </div>

      <div class="event-card">
        <img src="../assets/posters/pbf.jpg" alt="python bootcamp - 3">
        <div class="event-details">
          <h3>PYTHON BOOTCAMP FINALE</h3>
          <p>September 7, 2023</p>
          <a href="https://drive.google.com/file/d/1z8VjtbqOMhYnQVn-91e0BFXFLxdDMxJu/view?usp=sharing" target="_blank">Learn More</a>
        </div>
      </div>

      <div class="event-card">
        <img src="../assets/posters/ip.jpg" alt="image processing">
        <div class="event-details">
          <h3>INTRO TO IMAGE PROCESSING</h3>
          <p>September 21, 2023</p>
          <a href="https://drive.google.com/file/d/1HBEoQNh3l963Qb-Osh_nYfUygSfalCyl/view?usp=sharing" target="_blank">Learn More</a>
        </div>
      </div>

      <div class="event-card">
        <img src="../assets/posters/ann.jpg" alt="image processing">
        <div class="event-details">
          <h3>ARTIFICIAL NEURAL NETWORKS IN AUTONOMOUS VEHICLES</h3>
          <p>October 4, 2023</p>
          <a href="https://drive.google.com/file/d/1TdRz7Lh8m72PK4HtZgHN8sT6KsN43cax/view?usp=sharing" target="_blank">Learn More</a>
        </div>
      </div>

      <div class="event-card">
        <img src="../assets/posters/obj.jpg" alt="image processing">
        <div class="event-details">
          <h3>OBJECT DETECTION AND REALTIME PERCEPTION</h3>
          <p>October 11, 2023</p>
          <a href="https://docs.google.com/document/d/1lTW93EWkM3dhMe-3lrdfhZ8AYhRQBkqP/edit?usp=sharing&ouid=111409979811802577162&rtpof=true&sd=true" target="_blank">Learn More</a>
        </div>
      </div>
      <!-- Add more events as needed -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventsPage',
};
</script>

<style scoped>
.events-page {
  padding: 2rem 1rem;
  text-align: center;
}

.events-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.event-card {
  width: 550px;
  margin: 1rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
}

.event-card:hover {
  transform: scale(1.05);
}

.event-card img {
  width: 100%;
  height: auto;
  border-radius: 8px 8px 0 0;
}

.event-details {
  padding: 1rem;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.event-details h3 {
  margin-bottom: 0.5rem;
  font-size: 0.6cm;
}

.event-details p {
  color: #555;
  margin-bottom: 0.5rem;
  font-size: large;
  font-weight: bold;
}

.event-details a {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s ease-in-out;
}

.event-details a:hover {
  background-color: #2980b9;
}
</style>
